import { Component, OnInit, ViewChild } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { GroupsService } from "..";
import { SchoolService } from "../../../shared/services/school.service";
// import { FullCalendar } from "primeng/fullcalendar";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { ScheduleEditEventComponent } from "./schedule-edit-event/schedule-edit-event.component";
import { GroupsEditEventComponent } from "../define-events/groups-edit-event/groups-edit-event.component";
import { ScheduledEventDialogComponent } from "./scheduled-event-dialog/scheduled-event-dialog.component";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import * as moment from "moment";

@Component({
	selector: "app-events-scheduled-events",
	templateUrl: "./events-scheduled-events.component.html",
	styleUrls: ["./events-scheduled-events.component.css", "../groups.css"],
})
export class EventsScheduledEventsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private groupService: GroupsService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.InitOptions();
		this.UpdateDates("Init");
		// this.loadSchool(); //Load school then get event data
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	ngAfterViewInit() {
		document.getElementsByClassName("fc-next-button")[0].addEventListener("click", () => {
			this.UpdateDates("Next"); // call method
		});

		document.getElementsByClassName("fc-prev-button")[0].addEventListener("click", () => {
			this.UpdateDates("Prev"); // call method
		});

		document.getElementsByClassName("fc-today-button")[0].addEventListener("click", () => {
			this.UpdateDates("Init"); // call method
		});
	}

	////////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////////

	subscription: any;

	CurrentDate: Date = new Date();

	LoadingSchool: any = true;
	SchoolID: any = -1;
	schoolList: any = [];

	Year: any = moment(new Date()).format("YYYY");
	Month: any = moment(new Date()).format("MM");

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	LoadingEvent: any = true;
	lstDefineEvent: any = [];
	LoadingSchedule: any = true;
	lstSchedule: any = [];
	lstScheduledEvent: any = [];

	lstAllEvent: any = [];

	//Calendar
	lstFormatted: any = [];
	options: any = [];
	// @ViewChild('ScheduledEvents') private calendar: FullCalendar;

	//Popup
	SelectedEventData = {
		EventID: 0,
		EventName: "",
		EventDesc: "",
		EventLocation: "",
	};

	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////////

	loadSchool() {
		this.LoadingSchool = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;
				this.SchoolID = this.schoolList[0].SchoolID;

				this.LoadingSchool = false;

				this.loadEvents();
			},
			(error) => {
				this.LoadingSchool = false;
			}
		);
	}

	loadEvents() {
		// console.log("Load Events");

		this.LoadingEvent = true;

		this.lstFormatted = [];

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		var result = this.groupService.C9EventsGetList(this.SchoolID, fsDate, feDate, 2);
		result.subscribe(
			(response) => {
				this.lstDefineEvent = response;

				this.LoadingEvent = false;

				this.loadSchedule();
			},
			(error) => {
				this.LoadingEvent = false;
			}
		);
	}

	loadSchedule() {
		// console.log("Load Schedule");

		this.LoadingSchedule = true;

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		var result = this.groupService.C9ScheduleGetList(this.SchoolID, fsDate, feDate, 2);
		result.subscribe(
			(response) => {
				this.lstSchedule = response;

				this.LoadingSchedule = false;

				this.GetAllScheduledEvents();
			},
			(error) => {
				this.LoadingSchedule = false;
			}
		);
	}

	GetAllScheduledEvents() {
		// console.log("Get all scheduled events");

		// if(this.lstDefineEvent.length == 0 && this.lstSchedule == 0){
		//   return;
		// }

		this.lstScheduledEvent = [];

		// console.log("Schedule:");
		// console.log(this.lstSchedule);

		for (var i = 0; i < this.lstSchedule.length; i++) {
			var nextS = this.lstSchedule[i];

			// console.log("Next Schedule");
			// console.log(nextS);

			//
			// Check recurring events
			//

			if (nextS.RecurranceTypeID == 1) {
				this.WeeklyRecurrence(nextS);
			} else if (nextS.RecurranceTypeID == 2) {
				this.MonthlyRecurrence(nextS);
			} else if (nextS.RecurranceTypeID == 3) {
				this.YearlyRecurrence(nextS);
			}
		}

		this.PopulateGrid();
	}

	WeeklyRecurrence(s) {
		// console.log("Weekly, Schedule");
		// console.log(s);

		var recurCount = s.WeekRecurCount;
		var eventDT: Date;
		var rsDate: Date = new Date(s.RangeStartDate);

		if (this.StartDate >= rsDate) {
			eventDT = new Date(this.StartDate.getFullYear(), this.StartDate.getMonth(), this.StartDate.getDate());
		} else {
			eventDT = new Date(s.RangeStartDate);
		}

		while (eventDT.getMonth() == this.StartDate.getMonth()) {
			// console.log("Event DT");
			// console.log(eventDT);
			// console.log("Range Start");
			// console.log(rsDate);
			// console.log("Start Date");
			// console.log(this.StartDate);

			var ts: any = Math.abs(eventDT.getTime() - rsDate.getTime());

			// console.log("TS");
			// console.log(ts);

			var Days: any = ts / (1000 * 60 * 60 * 24);
			var Diff: any = Days % (recurCount * 7);

			// console.log("Days");
			// console.log(Days);
			// console.log("Diff");
			// console.log(Diff);

			if (Diff < 7) {
				// console.log("Diff < 7");
				// console.log("Event DT: Day of Week");
				// console.log(eventDT.getDay());
				// console.log("Schedule");
				// console.log("Mon " + s.WeekDayMonInd);
				// console.log("Tue " + s.WeekDayTueInd);
				// console.log("Wed " + s.WeekDayWedInd);
				// console.log("Thu " + s.WeekDayThuInd);
				// console.log("Fri " + s.WeekDayFriInd);
				// console.log("Sat " + s.WeekDaySatInd);
				// console.log("Sun " + s.WeekDaySunInd);

				if (
					(s.WeekDayMonInd && eventDT.getDay() == 1) ||
					(s.WeekDayTueInd && eventDT.getDay() == 2) ||
					(s.WeekDayWedInd && eventDT.getDay() == 3) ||
					(s.WeekDayThuInd && eventDT.getDay() == 4) ||
					(s.WeekDayFriInd && eventDT.getDay() == 5) ||
					(s.WeekDaySatInd && eventDT.getDay() == 6) ||
					(s.WeekDaySunInd && eventDT.getDay() == 0)
				) {
					// console.log("Adding event");
					// console.log(new Date(eventDT.getFullYear(), eventDT.getMonth(), eventDT.getDate()));

					var se = {
						EventDescription: s.EventDescription,
						EventDT: new Date(eventDT.getFullYear(), eventDT.getMonth(), eventDT.getDate()),
						ScheduleID: s.ScheduleID,
					};

					this.lstScheduledEvent = [...this.lstScheduledEvent, se];
				}
			}

			eventDT.setDate(eventDT.getDate() + 1);
			// console.log("Event DT Changed to");
			// console.log(eventDT);
		}
	}

	MonthlyRecurrence(s) {
		// console.log("Monthly, Schedule");
		// console.log(s);

		//
		// Every Day of Month
		//
		if (s.RecurrancePatternTypeID == 1) {
			var rsDate: Date = new Date(s.RangeStartDate);

			var eventDT: Date = new Date(this.StartDate.getFullYear(), this.StartDate.getMonth(), s.MonthEveryDOM);

			var Months: any = Math.abs(eventDT.getMonth() - rsDate.getMonth());

			// console.log("Recur Count");
			// console.log(s.MonthEveryRecurCount);

			// console.log("Months");
			// console.log(Months);

			if (s.MonthEveryRecurCount == 1 || Months % s.MonthEveryRecurCount == 0) {
				// console.log("Add Date: ");
				// console.log(eventDT);

				if (eventDT.getTime() >= rsDate.getTime()) {
					var se = {
						EventDescription: s.EventDescription,
						EventDT: new Date(eventDT.getFullYear(), eventDT.getMonth(), eventDT.getDate()),
						ScheduleID: s.ScheduleID,
					};

					this.lstScheduledEvent = [...this.lstScheduledEvent, se];
				}
			}
		}
		//
		// On particular day of a week
		//
		else {
			var rsDate: Date = new Date(s.RangeStartDate);

			var Months: any = Math.abs(rsDate.getMonth() - this.StartDate.getMonth());

			if (s.MonthOnRecurCount == 1 || Months % s.MonthOnRecurCount == 0) {
				rsDate.setMonth(rsDate.getMonth() + Months);

				eventDT = this.GetWeekDate(rsDate, s.MonthOnWeekNbr, s.MonthOnDOW);

				if (eventDT.getTime() >= rsDate.getTime()) {
					var se = {
						EventDescription: s.EventDescription,
						EventDT: new Date(eventDT.getFullYear(), eventDT.getMonth(), eventDT.getDate()),
						ScheduleID: s.ScheduleID,
					};

					this.lstScheduledEvent = [...this.lstScheduledEvent, se];
				}
			}
		}
	}

	//
	// Ex. Starting on 2/9/2022, Get 4th Monday
	//
	GetWeekDate(StartDate: Date, WeekNr: number, WeekDay: number) {
		var FirstOfMonth: Date = new Date(StartDate.getFullYear(), StartDate.getMonth(), 1);
		var Current: Date = new Date(StartDate.getFullYear(), StartDate.getMonth(), 1);

		//
		// Create list of Week Day and Week NBR
		// Ex. Feb/2022, Mondays: [2/7/22, 2/14/22, 2/21/22, 2/28/22]
		//

		var DayList: Date[] = [];

		while (Current.getMonth() == FirstOfMonth.getMonth()) {
			// console.log("Current");
			// console.log(Current);

			if (Current.getDay() == WeekDay) {
				DayList = [...DayList, new Date(Current.getFullYear(), Current.getMonth(), Current.getDate())];
			}

			Current.setDate(Current.getDate() + 1);
		}

		// console.log("Day List");
		// console.log(DayList);

		//Last
		if (WeekNr > 4) {
			return DayList[DayList.length - 1];
		} else {
			return DayList[WeekNr - 1];
		}
	}

	YearlyRecurrence(s) {
		// console.log("Yearly, Schedule");
		// console.log(s);

		var Counter = 0;

		//
		// Every x Day of month in a year
		//
		if (s.RecurrancePatternTypeID == 1) {
			var nextDate: Date;

			//Error if Every 31st of month but month has 28 days
			try {
				nextDate = new Date(this.StartDate.getFullYear(), s.YearEveryMOY, s.YearEveryDOM);
			} catch (e) {
				e.toString();
			}

			if (nextDate != undefined) {
				if (
					nextDate.getMonth() == this.StartDate.getMonth() ||
					nextDate.getMonth() == this.StartDate.getMonth() + 1 /////???
				) {
					var se = {
						EventDescription: s.EventDescription,
						EventDT: new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate()),
						ScheduleID: s.ScheduleID,
					};

					this.lstScheduledEvent = [...this.lstScheduledEvent, se];
				}
			}
		}
		//
		// On a particular day of the week
		//
		else {
			var FirstDOM = new Date(this.StartDate.getFullYear(), s.YearOnMonth, 1);

			var nextDate: Date = this.GetWeekDate(FirstDOM, s.YearOnWeekNbr, s.YearOnDOW);

			if (
				nextDate.getMonth() == this.StartDate.getMonth() ||
				nextDate.getMonth() == this.StartDate.getMonth() + 1 //??
			) {
				var se = {
					EventDescription: s.EventDescription,
					EventDT: new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate()),
					ScheduleID: s.ScheduleID,
				};

				this.lstScheduledEvent = [...this.lstScheduledEvent, se];
			}
		}
	}

	PopulateGrid() {
		// console.log("Populate Grid");

		this.lstAllEvent = [];

		//
		// Go through Defined Events list
		//

		for (var i = 0; i < this.lstDefineEvent.length; i++) {
			var next = this.lstDefineEvent[i];

			var EventDescriptionID = next.EventDescription.EventDescriptionID;

			var ScheduledList: any = [];

			//
			// Get a list of scheduled events with the same description
			//

			for (var z = 0; z < this.lstScheduledEvent.length; z++) {
				var nextS = this.lstScheduledEvent[z];

				if (nextS.EventDescription.EventDescriptionID == EventDescriptionID) {
					ScheduledList = [...ScheduledList, nextS];
				}
			}

			//
			// If there aren't any, just add the event (One time)
			//
			if (ScheduledList.length == 0) {
				this.lstAllEvent = [...this.lstAllEvent, next];
			}
			//
			// Else don't add but update the matching scheduled events
			// with the correct Event ID
			//
			else {
				for (var x = 0; x < ScheduledList.length; x++) {
					var nextS = ScheduledList[x];

					// console.log("Next");
					// console.log(next);
					// console.log("NextS");
					// console.log(nextS);

					//
					// Only add Event ID to Event Instances
					//
					if (moment(nextS.EventDT).format("MM/DD/YYYY") == moment(next.EventDT).format("MM/DD/YYYY")) {
						nextS.EventID = next.EventID;
					}

					// nextS.EventID = next.EventID;
				}
			}
		}

		//
		// Add all entries from scheduled events
		//
		for (var i = 0; i < this.lstScheduledEvent.length; i++) {
			var next = this.lstScheduledEvent[i];

			this.lstAllEvent = [...this.lstAllEvent, next];
		}

		//
		//
		//

		var DateToAdd: Date = new Date();

		var FirstDateOfMonth: Date = new Date(this.StartDate.getFullYear(), this.StartDate.getMonth(), 1);

		// console.log("All Events");
		// console.log(this.lstAllEvent);

		this.FormatEvents();
	}

	FormatEvents() {
		// console.log("Format");

		this.lstFormatted = [];

		this.lstFormatted = [
			{
				title: "Today",
				start: moment(new Date()).format("YYYY-MM-DD").toString(),
				end: moment(new Date()).format("YYYY-MM-DD").toString(),
				id: "0",
			},
		];

		for (var i = 0; i < this.lstAllEvent.length; i++) {
			var next = this.lstAllEvent[i];

			// console.log("Next");
			// console.log(next);

			var e = {
				title: next.EventDescription.EventDescShort,
				start: moment(next.EventDT).format("YYYY-MM-DD").toString(),
				end: moment(next.EventDT).format("YYYY-MM-DD").toString(),
				EventID: next.EventID == undefined ? -1 : next.EventID,
				ScheduleID: next.ScheduleID == undefined ? -1 : next.ScheduleID,
				EventDescription: next.EventDescription,
			};

			// console.log("Formatted:");
			// console.log(e);

			this.lstFormatted = [...this.lstFormatted, e];
		}

		// console.log("All Formatted");
		// console.log(this.lstFormatted);
	}

	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;

		this.loadEvents();
	}
	////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////////

	InitOptions() {
		this.options = {
			plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
			defaultDate: moment(new Date()).format("YYYY-MM-DD"),
			initialView: "dayGridMonth",
			headerToolbar: {
				left: "prev,next",
				center: "title",
				right: "dayGridMonth,timeGridWeek,timeGridDay",
			},

			//Open popup
			//Handle Event Clicks Here
			eventClick: (e) => {
				// Cancel if loading
				if (this.LoadingSchool == true || this.LoadingEvent || this.LoadingEvent) {
					return;
				}

				// console.log("Click");
				// console.log(e);

				/////////////////////////////////////////////////////////////////////
				// New Version
				/////////////////////////////////////////////////////////////////////

				var ed = e.event._def.extendedProps.EventDescription;
				var eID = e.event._def.extendedProps.EventID;
				var sID = e.event._def.extendedProps.ScheduleID;

				//
				// Do you want to edit this instance or the schedule?
				//

				if (eID > 0 && sID > 0) {
					this.ConfirmEditSchedule(ed, eID, sID);
				} else {
					this.EditSchedule(ed, eID, sID);
				}

				/////////////////////////////////////////////////////////////////////

				/////////////////////////////////////////////////////////////////////
				// Old Version
				/////////////////////////////////////////////////////////////////////

				// var ed = e.event._def.extendedProps.EventDescription;
				// if(ed == undefined){
				//   return;
				// }

				// this.SelectedEventData.EventName = ed.EventDescShort;
				// this.SelectedEventData.EventDesc = ed.EventDescLong;
				// this.SelectedEventData.EventLocation = ed.EventLocation;

				//Show popup
				// var ref = this.dialogService.open(ScheduleEditEventComponent, {
				//   header: "View Details",
				//   width: 'fit-content',
				//   data: {
				//     EventName: this.SelectedEventData.EventName,
				//     EventDesc: this.SelectedEventData.EventDesc,
				//     EventLocation: this.SelectedEventData.EventLocation
				//   }
				// });
				// ref.onClose.subscribe((response) => {
				//   if (response == 1)
				//   {

				//   }
				// });

				/////////////////////////////////////////////////////////////////////

				// this.scheduleData.showEventPopup = true;
			},
		};
	}

	ConfirmEditSchedule(ed, eID, sID) {
		//EventDescription, EventID, ScheduleID
		var ref = this.dialogService.open(ScheduledEventDialogComponent, {
			header: "Open Recurring Event",
			width: "fit-content",
			data: {
				EventDescription: ed,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == "Event") {
				this.EditSchedule(ed, eID, -1);
			} else if (response == "Schedule") {
				this.EditSchedule(ed, eID, sID);
			}
		});
	}

	EditSchedule(ed, eID, sID) {
		//EventDescription, EventID, ScheduleID
		var Header = "";
		if (sID > 0) {
			Header = "Edit Schedule";
		} else {
			Header = "Edit Event";
		}

		var ref = this.dialogService.open(GroupsEditEventComponent, {
			header: Header,
			width: "fit-content",
			data: {
				SchoolID: this.SchoolID,
				EventID: eID,
				ScheduleID: sID,
				EventDescriptionID: ed.EventDescriptionID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadEvents();
			}
		});
	}

	UpdateDates(Option) {
		////////////////////////////////////////

		if (Option == "Init") {
			var Today = new Date();

			this.CurrentDate = new Date(Today.getFullYear(), Today.getMonth(), 1);

			this.StartDate = new Date(Today.getFullYear(), Today.getMonth(), 1);
			this.EndDate = new Date(Today.getFullYear(), Today.getMonth() + 1, 1);
			this.EndDate.setDate(this.EndDate.getDate() - 1);

			// console.log("Start");
			// console.log(this.StartDate);
			// console.log("End");
			// console.log(this.EndDate);

			// this.loadSchool();
			this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
				// this.SchoolID = school.SchoolID;
				this.onSchoolChange(school.SchoolID);
			});
		} else if (Option == "Next") {
			this.CurrentDate.setMonth(this.CurrentDate.getMonth() + 1);
			this.StartDate = new Date(this.CurrentDate.getFullYear(), this.CurrentDate.getMonth(), 1);
			this.EndDate = new Date(this.CurrentDate.getFullYear(), this.CurrentDate.getMonth() + 1, 1);
			this.EndDate.setDate(this.EndDate.getDate() - 1);

			// console.log("Start");
			// console.log(this.StartDate);
			// console.log("End");
			// console.log(this.EndDate);

			this.loadEvents();
		} else if (Option == "Prev") {
			this.CurrentDate.setMonth(this.CurrentDate.getMonth() - 1);
			this.StartDate = new Date(this.CurrentDate.getFullYear(), this.CurrentDate.getMonth(), 1);
			this.EndDate = new Date(this.CurrentDate.getFullYear(), this.CurrentDate.getMonth() + 1, 1);
			this.EndDate.setDate(this.EndDate.getDate() - 1);

			// console.log("Start");
			// console.log(this.StartDate);
			// console.log("End");
			// console.log(this.EndDate);

			this.loadEvents();
		}
	}

	////////////////////////////////////////////////////////////////////////////
}
